export default __webpack_public_path__ + "static/lb-10-42277973afef54978beb804e80daa557.webp";